/**
 * Billing Service - API client for platform subscription endpoints
 * Uses authenticated API utility to include JWT tokens in requests
 */
import api from '../utils/api';

const billingService = {
  /**
   * Generate subscription for academic term
   */
  generateTermSubscription: async (academicTermId) => {
    try {
      const data = await api.post('/api/billing/subscriptions/generate-term', {
        academic_term_id: academicTermId
      });
      return data;
    } catch (error) {
      console.error("Error generating subscription:", error);
      throw error;
    }
  },

  /**
   * Get current subscription
   */
  getCurrentSubscription: async () => {
    try {
      const data = await api.get('/api/billing/subscriptions/current');
      return data;
    } catch (error) {
      console.error("Error fetching current subscription:", error);
      throw error;
    }
  },

  /**
   * Get subscription by ID
   */
  getSubscription: async (subscriptionId) => {
    try {
      const data = await api.get(`/api/billing/subscriptions/${subscriptionId}`);
      return data;
    } catch (error) {
      console.error("Error fetching subscription:", error);
      throw error;
    }
  },

  /**
   * Get all subscriptions (paginated)
   */
  getSchoolSubscriptions: async (limit = 10, offset = 0) => {
    try {
      const data = await api.get('/api/billing/subscriptions', {
        params: { limit, offset }
      });
      return data;
    } catch (error) {
      console.error("Error fetching subscriptions:", error);
      throw error;
    }
  },

  /**
   * Get all invoices (paginated)
   */
  getInvoices: async (limit = 10, offset = 0) => {
    try {
      const data = await api.get('/api/billing/invoices', {
        params: { limit, offset }
      });
      return data;
    } catch (error) {
      console.error("Error fetching invoices:", error);
      throw error;
    }
  },

  /**
   * Initiate subscription payment via Paystack
   */
  initiatePayment: async (subscriptionId, amountToPay = null) => {
    try {
      const data = await api.post(
        `/api/billing/subscriptions/${subscriptionId}/pay`,
        { 
          subscription_id: subscriptionId,
          amount_to_pay: amountToPay 
        }
      );
      return data;
    } catch (error) {
      console.error("Error initiating payment:", error);
      throw error;
    }
  },

  /**
   * Get subscription metrics for dashboard
   */
  getMetrics: async () => {
    try {
      const data = await api.get('/api/billing/metrics');
      return data;
    } catch (error) {
      console.error("Error fetching metrics:", error);
      throw error;
    }
  },

  /**
   * Download invoice as PDF
   */
  downloadInvoice: async (invoiceId) => {
    try {
      const response = await api.get(`/api/billing/invoices/${invoiceId}/download`, {
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      console.error("Error downloading invoice:", error);
      throw error;
    }
  }
};

export default billingService;
